import react from "react";
import { Box, IconButton } from "@mui/material";
import { styled } from "@mui/system";
import muiTheme from "../../../../themes/muiTheme";

const IndexContainer = styled(Box)<{ width: number; isPortrait: boolean }>(
  ({ width, isPortrait }) => ({
    display: "flex",
    width: !isPortrait ? 240 : "100%",
    height: 52,
    alignItems: "center",
    justifyContent: "space-between",
    borderTopLeftRadius: !isPortrait ? 8 : 0,
    backgroundColor: muiTheme.palette.blue[500],
    position: "fixed",
    top: 0,
    right: 0,
    zIndex: 2,
  })
);

interface Props {
  windowWidth: number;
  isOpen: boolean;
  isPortrait: boolean;
  setIsOpenDrawer: React.Dispatch<React.SetStateAction<boolean>>;
}

export const NavBar = ({
  windowWidth,
  isOpen,
  isPortrait,
  setIsOpenDrawer,
}: Props) => {
  return (
    <Box sx={{}}>
      <IndexContainer
        width={!isPortrait ? 240 : windowWidth}
        isPortrait={isPortrait}
      >
        <Box
          component="img"
          src={process.env.PUBLIC_URL + "/img/ic_tlc_logo.png"}
          sx={{ width: 114, height: 24, pl: 2 }}
        />
        <Box
          onClick={() => setIsOpenDrawer(!isOpen)}
          sx={{
            width: 52,
            height: 52,
            bgcolor: muiTheme.palette.blue[500],
            alignItems: "center",
            justifyContent: "center",
            ":hover": {
              backgroundColor: isPortrait ? null : muiTheme.palette.blue[600],
            },
          }}
        >
          <Box
            component="img"
            src={process.env.PUBLIC_URL + "/img/ic_close_white.png"}
            sx={{ width: 24, height: 24 }}
          />
        </Box>
      </IndexContainer>
      <Box
        sx={{
          width: !isPortrait ? 240 : windowWidth,
          height: 16,
          bgcolor: "white",
          position: "fixed",
          top: 52,
          right: 0,
        }}
      />
    </Box>
  );
};
